// AUTO-GENERATED friendly aliases for the migrated engravings.
import type { EngravingData } from "./engraving";
import { E } from "./brand";

export const F = {
  heroPlate: E["engraved-armillary-twin-globe-with-orbit-s"]!,
  architectSheet: E["architectural-drawing-sheet-of-the-busines"]!,
  loopDial: E["top-down-operating-loop-dial-with-four-sta"]!,
  spot96: E["fig3"]!,
  spot64: E["fig4"]!,
  spot48: E["fig5"]!,
  spot32: E["fig6"]!,
  spot24: E["fig7"]!,
  spotReversed: E["fig8"]!,
  spotAvatar: E["fig9"]!,
  darkPanel: E["the-twin-engraved-in-accent-lines-on-the-t"]!,
  twinmarkDefs: E["fig11"]!,
} satisfies Record<string, EngravingData>;
